import {
  type EdgeId,
  type TrafficScore,
  isPathLookupEdgeData,
} from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';

export const getTrafficScore = (
  graphData: GraphData,
  edgeId: EdgeId,
): TrafficScore | null => {
  const foundEdge = graphData.edges[edgeId];
  if (foundEdge !== undefined && isPathLookupEdgeData(foundEdge)) {
    return foundEdge.trafficScore;
  }

  return null;
};
